import React, { HTMLAttributes, ReactNode } from 'react';
import './HeroOverlap.css';
import { ITitleProps } from 'component-library/atoms/Title/Title';
import { Section, Container, Row, Col, Title } from '../../../importCL';

type IHeroProps = Omit<HTMLAttributes<any>, 'title'>;

export interface IHeroOverlapProps extends IHeroProps {
	title?: ITitleProps['children'];
	bgimg?: string;
	children?: ReactNode;
	ariaLabel?: string;
	removetitleHr?: boolean;
	showBottomBorder?: boolean;
	bgColor?: string;
}

const HeroOverlap = ({
	title,
	bgimg,
	children,
	className = '',
	ariaLabel = '',
	removetitleHr = false,
	showBottomBorder = false,
	bgColor = 'white',
	...rest
}: IHeroOverlapProps) => {
	const isBgDark = bgColor === 'blue-creditone' || bgColor === 'purple';
	return (
		<div className={`bg-${bgColor === 'light-grey' ? 'grey-lightest' : bgColor}`}>
			<Section
				ariaLabel={ariaLabel}
				bgImg={bgimg}
				className={`HeroOverlap ${isBgDark ? 'HeroOverlap__bgDark' : ''} ${className}`}
				{...rest}
			/>
			<Container
				className={`HeroOverlap__container ${
					!showBottomBorder
						? 'HeroOverlap__container--noBottomBorder'
						: ''
				} HeroOverlap__container--${bgColor}` }
				as='section'
			>
				<Row className='HeroOverlap__row px-0 py-12' as='article'>
					<Col md={6} xs={6} className='HeroOverlap__column'>
						<Title
							showHr={!removetitleHr}
							className={`mb-6 ${isBgDark ? 'text-white' : 'text-grey-tundora'}`}
							tag='h1'
						>
							{title}
						</Title>
					</Col>
					<Col md={6} xs={6}>
						{children}
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default HeroOverlap;
